import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {
    IChecklist2ReportChecklistSummary,
    IChecklist2ReportDateRange,
    IChecklistHistoryDateRangeChangeEvent,
    IChecklistV2FilterAvailableItems,
    IChecklistV2ReportParameter,
    IChecklistV2ReportParameterFilter,
} from '../../../shared/fi-checklist2-report';
import { FiChecklist2ReportData } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-data';
import { ChecklistV2ReportPages } from '../../../enums/fi-checklist2-report-pages.enum';
import { FiChecklist2ReportStateService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-state.service';
import { FiChecklist2ReportDataService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-data.service';
import { FiChecklist2ReportHelperService } from '../../../services/fi-checklist2-report-helper.service';
import { INameIdObj } from '@fi-app/shared/fi-shared-interfaces';
import { FiChecklist2ReportTimePeriodType } from '../../../enums/fi-checklist2-report-time-period-type';

@Component({
    selector: 'fi-history-checklist-details-wrapper',
    templateUrl: './history-checklist-details-wrapper.component.html',
    styleUrls: ['./history-checklist-details-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-history-checklist-details-wrapper' },
    standalone: false,
})
export class FiHistoryChecklistDetailsWrapperComponent implements OnInit {
    @Input() reportParameter: IChecklistV2ReportParameter;
    @Input() reportData: FiChecklist2ReportData;
    @Input() checklistSummary: IChecklist2ReportChecklistSummary;
    @Input() currentFilter: IChecklistV2ReportParameterFilter;
    @Input() historyLoading: boolean;
    @Output() checklistHistoryDateRangeChange = new EventEmitter<IChecklistHistoryDateRangeChangeEvent>();
    @Output() showWidgetDetails = new EventEmitter<void>();
    protected checklistHistoryDateRange: IChecklist2ReportDateRange;
    protected checklistWidgetHistoryOptions: INameIdObj[];
    currentPastChecklistReportPage: ChecklistV2ReportPages = ChecklistV2ReportPages.ChecklistHistoryDetails;
    protected readonly FiChecklist2ReportTimePeriodType = FiChecklist2ReportTimePeriodType;
    constructor(
        private fiChecklist2ReportStateService: FiChecklist2ReportStateService,
        private fiChecklist2ReportDataService: FiChecklist2ReportDataService,
        private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
    ) {}

    ngOnInit(): void {
        if (this.fiChecklist2ReportStateService.hasPeriodTimeParams()) {
            this.fiChecklist2ReportDataService.setNewDateRange(
                this.reportParameter.Id,
                this.fiChecklist2ReportStateService.getDateRangeParam(),
            );
        }
        this.checklistWidgetHistoryOptions = this.fiChecklist2ReportHelperService.getChecklistReportHistoryOptions();

        this.checklistHistoryDateRange = this.fiChecklist2ReportDataService.getDateRange(this.reportParameter.Id);
    }

    get availableItems(): IChecklistV2FilterAvailableItems {
        return this.reportData.availableItems;
    }

    onChecklistHistoryDateRangeChange(checklistHistoryDateRange: IChecklist2ReportDateRange) {
        this.checklistHistoryDateRangeChange.emit({
            reportParameterId: this.reportParameter.Id,
            dateRange: checklistHistoryDateRange,
        });
    }

    backButtonClick() {
        if (this.currentPastChecklistReportPage === ChecklistV2ReportPages.ChecklistHistoryDetails)
            this.showWidgetDetails.emit();
        else this.currentPastChecklistReportPage = ChecklistV2ReportPages.ChecklistHistoryDetails;
    }

    protected readonly ChecklistV2ReportPages = ChecklistV2ReportPages;
}
